import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Pagination from './Pagination';
import QueryBar from './QueryBar';
import ParticipantsV2Store from './Store';
import ParticipantsV2Reactions from './Store/Reactions';
import SearchReactions from './Store/SearchReactions';
import Table from './Table';

function Participants() {
  const store = useMemo(() => new ParticipantsV2Store(), []);

  return (
    <div className="px-2.5 lg:px-12">
      <QueryBar store={store} />
      <Table store={store} />
      <Pagination store={store} />
      <ParticipantsV2Reactions store={store} fireImmediately />
      <SearchReactions store={store} debounceDelay={400} />
    </div>
  );
}

export default observer(Participants);
